import { useState, useMemo } from 'react'
import { getInitials } from '@legacy/common/Tools/Common'
import { AvatarWrapper, Initials } from './avatarStyled'
import { IAvatar, avatarType, avatarFont } from './avatarTypes'
import { isEmpty } from 'lodash'
import ProfilePicFallbackImage from '@legacy/assets/images/perfil-pic.png'

const MIN_AVATAR_DIMENSION = 2

export const Avatar = ({ name, image, size }: IAvatar) => {
  const [status, setStatus] =
    useState<'loading' | 'loaded' | 'failed'>('loading')
  const hasImage = useMemo(
    () => image !== undefined && image !== null && !isEmpty(image),
    [image],
  )

  const imageOnErrorHandler = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    if (status !== 'failed') {
      event.currentTarget.src = ProfilePicFallbackImage
      setStatus('failed')
    }
  }

  const imageOnLoadHandler = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    const img = event.currentTarget
    if (img.naturalWidth < MIN_AVATAR_DIMENSION || img.naturalHeight < MIN_AVATAR_DIMENSION) {
      setStatus('failed')
    } else {
      setStatus('loaded')
    }
  }

  const showInitials = !hasImage || status === 'failed'

  return (
    <AvatarWrapper size={avatarType[size]}>
      {hasImage && image !== null && status !== 'failed' ? (
        <img
          src={image}
          loading='lazy'
          decoding='async'
          width={avatarType[size]}
          height={avatarType[size]}
          alt={`${name} avatar`}
          title={name}
          onError={imageOnErrorHandler}
          onLoad={imageOnLoadHandler}
        />
      ) : (
        <Initials size={avatarFont[size]}>{getInitials(name)}</Initials>
      )}
    </AvatarWrapper>
  )
}

export default Avatar
